import styled from "styled-components";
import { InputHelperLabelProps } from "./InputHelperLabel.types";

export const Wrapper = styled.div<Partial<InputHelperLabelProps>>`
    display: inline-flex;
    gap: 7px;
`;
